import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Bus from "components/bus.js";
import { MU_UPATE_AUTH, MU_UPATE_SCHOOL } from "store/index";
import CryptoJS from "crypto-js";
export default {
  data: function data() {
    return {
      activeName: 'first',
      scanVisible: false,
      ruleForm: {
        userName: "",
        password: "",
        phone: "",
        captcha: "",
        schoolId: ""
      },
      phoneRuleForm: {
        phone: "",
        captcha: "",
        schoolId: ""
      },
      schoolInfo: [],
      rules: {
        userName: [{
          required: true,
          message: "请输入用户账号",
          trigger: "change"
        }],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "change"
        }]
      },
      phoneRules: {
        phone: [{
          required: true,
          message: "请输入手机号",
          trigger: "change"
        }],
        captcha: [{
          required: true,
          message: "请输入验证码",
          trigger: "change"
        }]
      },
      count: 60,
      show1: true,
      show2: false,
      show3: false,
      verifyCode: '',
      timer: ""
    };
  },
  props: {
    isShow: {
      type: Object,
      default: false
    }
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.auth;
    },
    association: function association() {
      return this.$store.state.association;
    }
  },
  created: function created() {
    this.getSchoolInfo();

    if (localStorage["userId"] !== undefined) {
      this.$store.dispatch(MU_UPATE_AUTH).then(function (rt) {});
    }

    this.$store.dispatch(MU_UPATE_SCHOOL, {
      id: window.location.href
    });
  },
  watch: {
    isShow: function isShow(val) {
      this.scanVisible = val.isShow;
    }
  },
  methods: {
    enterRegister: function enterRegister() {
      this.scanVisible = false;
      this.$router.push({
        name: "register"
      });
    },
    // 忘记密码
    rememberPassword: function rememberPassword() {
      this.$router.push({
        name: "password"
      });
    },
    openLoginDialog: function openLoginDialog() {
      this.scanVisible = true;
    },
    Phonelogin: function Phonelogin() {
      var _this = this;

      var that = this;
      this.loadingTip(true);
      this.$http.post("/api/XOrg/XLogin/Phonelogin", {
        phone: that.phoneRuleForm.phone,
        captcha: that.phoneRuleForm.captcha
      }).then(function (rst) {
        if (rst && rst.code > 0) {
          if (rst.code === 1) {
            localStorage["userName"] = _this.ruleForm.userName;
            localStorage["userId"] = rst.userId;
          }

          _this.$store.dispatch(MU_UPATE_AUTH).then(function (rt) {
            _this.loadingTip(false); // 登录完获取回登录信息跳转


            _this.scanVisible = false;

            _this.$router.push({
              name: _this.target_()
            });
          });
        } else {
          _this.loadingTip(false);

          _this.$message.warning(rst.msg);
        }
      });
    },
    login: function login() {
      var _this2 = this;

      var that = this;
      this.loadingTip(true);
      this.$http.post("/api/XOrg/XLogin/Accountlogin", {
        userName: that.ruleForm.userName,
        userPwd: that.ruleForm.password,
        schoolId: that.ruleForm.schoolId
      }).then(function (rst) {
        if (rst && rst.code > 0) {
          if (rst.code === 1) {
            localStorage["userName"] = _this2.ruleForm.userName;
            localStorage["userId"] = rst.userId;
          }

          _this2.$store.dispatch(MU_UPATE_AUTH).then(function (rt) {
            _this2.loadingTip(false); // 登录完获取回登录信息跳转


            _this2.scanVisible = false;

            _this2.$router.push({
              name: _this2.target_()
            });
          });
        } else {
          _this2.loadingTip(false);

          _this2.$message.warning(rst.msg);
        }
      });
    },
    sendMessage: function sendMessage() {
      var _this3 = this;

      var once = true;
      var str_ = Date.parse(new Date()) / 1000;
      var str = this.encryption(str_);
      var str1 = CryptoJS.MD5(str_ + "").toString();
      var s1 = str1.substring(0, 7);
      var s2 = str1.substring(7);
      str1 = s1 + "s" + s2;

      if (once) {
        var that = this;
        this.$http.post("/api/XOrg/XLogin/sendCode", {
          verifyInfo: that.phoneRuleForm.phone,
          str: str,
          str1: str1
        }).then(function (rst) {
          if (rst.code > 0) {
            _this3.$message.success(rst.msg);

            _this3.verifyCode = rst.verifyCode;
            var TIME_COUNT = 60;

            if (!_this3.timer) {
              _this3.count = TIME_COUNT;
              _this3.show1 = false;
              _this3.show2 = true;
              _this3.show3 = false;
              _this3.timer = setInterval(function () {
                if (_this3.count > 0 && _this3.count <= TIME_COUNT) {
                  _this3.count--;
                  once = false;
                } else {
                  _this3.show1 = false;
                  _this3.show2 = false;
                  _this3.show3 = true;
                  clearInterval(_this3.timer);
                  _this3.timer = null;
                  once = true;
                }
              }, 1000);
            }
          } else {
            _this3.$message.warning(rst.msg);
          }
        });
      }
    },
    encryption: function encryption(str) {
      var Base64 = require("js-base64").Base64;

      return Base64.encode(str);
    },
    //获取学校列表
    getSchoolInfo: function getSchoolInfo() {
      var that = this;
      this.$http.post("/api/XOrg/XLogin/getSchoolInfo").then(function (rst) {
        if (rst.code > 0) {
          that.schoolInfo = rst.schoolInfo;
        }
      });
    },
    loadingTip: function loadingTip(is) {
      if (is) {
        this.$loading({
          lock: true,
          text: "正在登录..."
        });
      } else {
        this.$loading({}).close();
      }
    },
    target_: function target_() {
      var Urlname = "";

      if (this.$store.state.auth.userType === 1) {
        Urlname = "stuBasicInfo";
      } else if (this.$store.state.auth.userType === 2) {
        // Urlname = "Accountlogin";
        Urlname = "managerIndex";
      } else if (this.$store.state.auth.userType === 3) {
        Urlname = "siteBasicInfo";
      } else if (this.$store.state.auth.userType === 9) {
        Urlname = "managerIndex";
      }

      return Urlname;
    }
  }
};